import { render } from "./SwiftList.vue?vue&type=template&id=94de22f6&scoped=true"
import script from "./SwiftList.vue?vue&type=script&lang=js"
export * from "./SwiftList.vue?vue&type=script&lang=js"

import "./SwiftList.vue?vue&type=style&index=0&id=94de22f6&scoped=true&lang=css"
import "./SwiftList.vue?vue&type=style&index=1&id=94de22f6&scoped=true&lang=scss"
import "./SwiftList.vue?vue&type=style&index=2&id=94de22f6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94de22f6"]])

export default __exports__